/**
 * Health status as an enum as the api-client does not generate and expose
 * HealthStatus.
 * TODO(AA): Generate unexposed enums for api-client to reduce duplicated
 * declarations.
 */
export var HealthStatus;
(function (HealthStatus) {
    HealthStatus["Healthy"] = "Healthy";
    HealthStatus["Unhealthy"] = "Unhealthy";
    HealthStatus["Dead"] = "Dead";
})(HealthStatus || (HealthStatus = {}));
/**
 * Returns the Op Mode based on the health status.
 * @param healthStatus The enum strings from HealthStatus
 * @returns Op mode
 */
export function healthStatusToOpMode(healthStatus) {
    switch (healthStatus) {
        case HealthStatus.Healthy:
            return 'ONLINE';
        case HealthStatus.Unhealthy:
            return 'UNSTABLE';
        case HealthStatus.Dead:
            return 'OFFLINE';
        default:
            return "Unknown " + healthStatus;
    }
}
